import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Flex } from '../../../components/Flex';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { SlotFlex } from './SlotFlex';
import { InnerFlex } from './InnerFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AbstractToolbar = _ref => {
  let {
      End,
      endSlot,
      Inner,
      Middle,
      middleSlot,
      Start,
      startSlot,
      __distributeEvenly,
      responsive,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["End", "endSlot", "Inner", "Middle", "middleSlot", "Start", "startSlot", "__distributeEvenly", "responsive", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const InnerComponent = Inner || InnerFlex;
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    role: "group",
    flexDirection: "row",
    marginBlock: "300"
  }, rest, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'AbstractToolbar',
    children: /*#__PURE__*/_jsxs(InnerComponent, {
      responsive: responsive,
      $justifyEnd: !!endSlot && !startSlot && !middleSlot,
      children: [startSlot && (Start ? /*#__PURE__*/_jsx(Start, {
        __distributeEvenly: __distributeEvenly,
        children: startSlot
      }) : /*#__PURE__*/_jsx(SlotFlex, {
        __distributeEvenly: __distributeEvenly,
        position: "start",
        children: startSlot
      })), middleSlot && (Middle ? /*#__PURE__*/_jsx(Middle, {
        __distributeEvenly: __distributeEvenly,
        children: middleSlot
      }) : /*#__PURE__*/_jsx(SlotFlex, {
        __distributeEvenly: __distributeEvenly,
        position: "middle",
        children: middleSlot
      })), endSlot && (End ? /*#__PURE__*/_jsx(End, {
        __distributeEvenly: __distributeEvenly,
        children: endSlot
      }) : /*#__PURE__*/_jsx(SlotFlex, {
        __distributeEvenly: __distributeEvenly,
        position: "end",
        children: endSlot
      }))]
    })
  }));
};
AbstractToolbar.displayName = 'AbstractToolbar';